import { Flex } from '@aloft/toolkit-sui';

import { IndicatedValue } from '../../../components/IndicatedValue.tsx';
import { SettingsControls } from '../../../components/Settings/SettingsControls.tsx';

export const AdjustmentsModuleTitle = () => (
  <Flex marginBottom=".5rem" flexDirection="row" alignItems="center" justifyContent="space-between">
    <IndicatedValue />
    <SettingsControls />
  </Flex>
);
